import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const navigationWrapperStyles = ({ theme }) => css`
  label: navigation;

  position: relative;

  margin: ${theme.spacings.mega} 0;

  display: flex;

  background: ${theme.colors.white};
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.109812);

  overflow-x: auto;

  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-track {
    display: none;
  }

  ${theme.media.mega} {
    margin-top: 0;
  }

  ${theme.media.giga} {
    display: none;
  }
`

export const itemStyles = ({ theme }) => css`
  label: navigation__item;

  position: relative;

  flex: 0 0 auto;

  padding: ${theme.spacings.byte} ${theme.spacings.mega};

  color: ${theme.colors.n600};

  ${theme.typography.text.kilo};

  vertical-align: baseline;

  &:after {
    content: '';

    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;

    width: calc(100% - ${theme.spacings.tera});
    height: 2px;

    margin: 0 auto;

    border-radius: ${theme.borderRadius.kilo};
  }
`

const activeGradient = theme => `linear-gradient(
  178.58deg,
  ${theme.colors.f600} 8.84%,
  ${theme.colors.v500} 91.71%
)`

export const itemActiveStyles = ({ theme, active }) =>
  active &&
  css`
    label: navigation__item--active;

    background: ${activeGradient(theme)};

    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    &:after {
      background: ${activeGradient(theme)};
    }
  `
